/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-empty-function */
import { Box, Flex, Progress, SimpleGrid, Text } from '@chakra-ui/react';
import { compareString, formatCurrency } from '@/utils';
import React, { useContext, useMemo } from 'react';
import { useWindowSize } from '@trustless-computer/dapp-core';
import Slider from 'react-slick';
import styles from './styles.module.scss';
import { chunk } from 'lodash';
import { HiArrowLeft, HiArrowRight } from 'react-icons/hi';
import px2rem from '@/utils/px2rem';
import InfoTooltip from '@/modules/AlphaPWA/Profiles/TradeKey/components/infoTooltip';
import HorizontalItem from '@/modules/AlphaPWA/Profiles/TradeKey/components/horizontalItem';
import { getUrlAvatarTwitter, shortenAddress } from '@/utils/helpers';
import { WalletContext } from '@/contexts/wallet-context';
import Avatar from '@/modules/AlphaPWA/Profiles/TradeKey/components/avatar';

const ProposalSide = ({
  title,
  currentVote,
  totalVote,
  className,
  data,
}: any) => {
  const { mobileScreen, tabletScreen } = useWindowSize();
  const { addressL2 } = useContext(WalletContext);
  const perPage = 10;

  const numSlide = useMemo(() => {
    return Math.floor((data?.length || 0) / perPage) + 1;
  }, [JSON.stringify(data)]);

  const pageData = useMemo(() => {
    const res = (data || []).concat(
      [...Array(perPage * numSlide - (data?.length || 0))].map(function () {})
    );
    return chunk(res, perPage);
  }, [JSON.stringify(data), numSlide]);

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };

  function SampleNextArrow(props: any) {
    const { className, style, onClick } = props;
    return (
      <Box className={className} style={{ ...style }} onClick={onClick}>
        <HiArrowRight fontSize={'30px'} color={'#FFFFFF'} />
      </Box>
    );
  }

  function SamplePrevArrow(props: any) {
    const { className, style, onClick } = props;
    return (
      <Box className={className} style={{ ...style }} onClick={onClick}>
        <HiArrowLeft fontSize={'30px'} color={'#FFFFFF'} />
      </Box>
    );
  }

  return (
    <Box className={className}>
      <Flex alignItems={'center'} justifyContent={'space-between'}>
        <Text className={'side-title'}>{title}</Text>
        <Text className={'side-total'} color={'#FFFFFF'}>
          {formatCurrency(currentVote)}
        </Text>
      </Flex>
      <Progress
        max={100}
        value={(Number(currentVote || 0) / totalVote) * 100}
        h="10px"
        className={'progress-bar'}
        mt={4}
      />
      <Slider {...settings} className={styles.listVote}>
        {pageData?.map((d: any, i: number) => {
          return (
            <Box key={i}>
              <SimpleGrid spacingY={4} columns={perPage / 2} w={'100%'}>
                {d?.map((d: any, index: number) => {
                  return d ? (
                    <Box key={d.voter?.address} paddingX={4}>
                      <InfoTooltip
                        label={
                          <Box pl="12px" pr="12px">
                            <HorizontalItem
                              label={
                                <Text color={'rgba(255, 255, 255, 0.7)'}>
                                  Amount
                                </Text>
                              }
                              value={
                                <Text color={'#FFFFFF'}>
                                  {formatCurrency(d.weight)}
                                </Text>
                              }
                            />
                          </Box>
                        }
                        key={d.voter?.address}
                        isStyleConfig={false}
                      >
                        <Avatar
                          url={getUrlAvatarTwitter(
                            d.voter?.twitter_avatar || '',
                            'medium'
                          )}
                          address={d.voter?.address || ''}
                          width={44}
                          onClick={() => {}}
                        />
                      </InfoTooltip>
                      {compareString(addressL2, d.voter.voter) && (
                        <Text
                          color={'rgba(255, 255, 255, 0.7)'}
                          textAlign={'center'}
                          mt={-2}
                          w={px2rem(mobileScreen || tabletScreen ? 40 : 60)}
                        >
                          You
                        </Text>
                      )}
                    </Box>
                  ) : (
                    <Box
                      key={index}
                      width={`${mobileScreen || tabletScreen ? 44 : 60}px`}
                      height={`${mobileScreen || tabletScreen ? 44 : 60}px`}
                      borderRadius={'50%'}
                      backgroundColor={'#3F3F3F'}
                      marginX={4}
                    ></Box>
                  );
                })}
              </SimpleGrid>
            </Box>
          );
        })}
      </Slider>
    </Box>
  );
};

export default ProposalSide;
